<template>
  <div>
    <div
      style="position: relative; margin-right: 20px; margin-left: 10px"
      class="mb-3"
    >
      <v-layout>
        <v-flex xs7 style="padding: 5px">
          <div class="mb-2" style="margin-left: 20px">
            <strong class="mr-2" style="font-size: 17px">{{
              project.bidderName
            }}</strong>
          </div>
          <div class="mb-2" style="margin-left: 20px; font-size: 15px">
            <strong class="mr-2" style="font-size: 15px"
              >Nazwa projektu:</strong
            >
            {{ project.title }}
          </div>
          <div class="mb-2" style="margin-left: 20px; font-size: 15px">
            <strong class="mr-2" style="font-size: 15px"
              >Numer projektu:</strong
            >
            {{ project.projectCode }}
          </div>
        </v-flex>
        <v-flex xs5 style="padding: 5px">
          <div
            style="
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: flex-end;
            "
            class="mr-2"
          >
            <strong v-if="getStatus || getExtraStatus" style="font-size: 16px"
              >Status: {{ getStatus }} {{ getExtraStatus }}</strong
            >
          </div>
          <div>
            <div
              style="
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-end;
              "
            >
              <v-btn class="grey" @click="hideProject" v-if="projectCanBeHidden"
                >Ukryj
              </v-btn>
              <v-btn
                class="grey"
                @click="undoHideProject"
                v-if="projectHidingCanBeUndone"
                >Cofnij ukrycie
              </v-btn>
              <v-btn
                class="grey darken-1"
                @click="archiveProject"
                v-if="projectCanBeArchived"
                >Archiwizuj
              </v-btn>
              <v-btn
                class="grey darken-1"
                @click="undoArchiveProject"
                v-if="projectArchivingCanBeUndone"
                >Cofnij archiwizację
              </v-btn>
              <v-btn
                class="success"
                @click="undoProjectWithdrawal"
                v-if="projectWithdrawalCanBeUndone()"
                >Cofnij anulowanie projektu
              </v-btn>
              <v-btn
                class="success"
                @click="approveProject"
                v-if="projectCanBeApproved()"
                >Zatwierdź
              </v-btn>
              <v-btn
                class="red lighten-3"
                @click="withdrawal.dialog = true"
                v-if="projectCanBeWithdrawn()"
                >Anuluj projekt
              </v-btn>
              <v-btn
                color="accent"
                dark
                @click="finishProject"
                v-if="projectCanBeFinished"
              >
                <v-icon color="white" left>assignment_turned_in</v-icon>
                Zakończ projekt
              </v-btn>
              <v-btn
                color="accent"
                dark
                @click="undoFinishProject"
                v-if="projectFinishingCanBeUndone"
              >
                <v-icon color="white" left>assignment_return</v-icon>
                Cofnij zakończenie projektu
              </v-btn>
              <v-btn
                class="warning"
                @click="correction.dialog = true"
                v-if="projectCanHaveRequestChanges()"
                >Do poprawki
              </v-btn>
              <v-btn
                v-if="possibleToUndoneApproval()"
                class="error"
                @click="undoApproval()"
                >Cofnij zatwierdzenie
              </v-btn>
              <v-btn
                v-if="possibleToUndoneRequestChanges()"
                class="error"
                @click="undoRequestChanges"
                >Cofnij oddanie do poprawki
              </v-btn>
              <v-btn
                class="error"
                v-if="possibleToUndoAgreementSigned()"
                @click="undoAgreementSigned"
                >Cofnij podpisanie umowy
              </v-btn>
              <v-btn
                class="error"
                v-if="possibleToUndoAnnexApplication()"
                @click="undoAnnexApplication"
                >Cofnij przyjęcie wniosku o podpisanie aneksu
              </v-btn>
              <v-btn
                class="error"
                v-if="possibleToUndoAddAnnex()"
                @click="undoAddAnnex"
                >Cofnij podpisanie aneksu
              </v-btn>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
              "
            >
              <v-btn class="accent" @click="mailTo()">
                <v-icon color="white" left>mail</v-icon>
                Wyślij email
              </v-btn>
              <v-btn color="accent" dark @click="viewProject">
                <v-icon color="white" left>description</v-icon>
                Podgląd
              </v-btn>
              <v-btn color="accent" dark @click="moveToHistory">
                <v-icon color="white" left>history</v-icon>
                Historia
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <router-link :to="{ path: 'agreement' }" replace>
      <v-btn>Umowy i aneksy</v-btn>
    </router-link>
    <router-link :to="{ path: 'correspondence' }" replace>
      <v-btn>Korespondencja</v-btn>
    </router-link>
    <router-link :to="{ path: 'amounts' }" replace>
      <v-btn>Kwoty</v-btn>
    </router-link>
    <router-link :to="{ path: 'terms' }" replace>
      <v-btn>Terminy</v-btn>
    </router-link>
    <router-link :to="{ path: 'evaluation' }" replace>
      <v-btn>Przebieg współpracy</v-btn>
    </router-link>
    <router-link :to="{ path: 'monitoring' }" replace>
      <v-btn>Monitoring</v-btn>
    </router-link>
    <router-link :to="{ path: 'volunteer-reports' }" replace>
      <v-btn>Raporty wolontariuszy</v-btn>
    </router-link>
    <router-link :to="{ path: 'final-report' }" replace>
      <v-btn>Sprawozdanie końcowe</v-btn>
    </router-link>
    <router-link :to="{ path: 'donation-contract' }" replace>
      <v-btn>Karty Umowy Dotacji</v-btn>
    </router-link>
    <router-view v-bind:project="project" v-on:refresh="refresh" />

    <v-dialog v-model="correction.dialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">Przekazanie projektu do poprawek</span>
        </v-card-title>
        <v-card-text>
          <v-alert value="true" type="info" class="mb-3">
            Przekazanie projektu do poprawek spowoduje skasowanie treści
            sprawozdania końcowego.<br />
            Jeżeli podpisany plik sprawozdania końcowego został załączony do
            projektu, to zostanie on usunięty.
          </v-alert>
          <v-text-field
            browser-autocomplete="off"
            data-vv-name="correctionCause"
            data-vv-as="Powód przekazania do poprawek"
            label="Powód przekazania do poprawek"
            :error-messages="vErrors.collect('correctionCause')"
            v-validate="'required'"
            @keydown="onKeyDownEvent"
            v-model="correction.cause"
            aria-label="detailed correction cause"
          >
          </v-text-field>
          <v-textarea
            browser-autocomplete="off"
            data-vv-name="detailedCorrectionCause"
            data-vv-as="Opis szczegółowy"
            label="Opis szczegółowy"
            v-model="correction.detailedCause"
            :error-messages="vErrors.collect('detailedCorrectionCause')"
            v-validate="'required'"
            aria-label="detailed correction cause"
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="correction.cause !== '' && correction.detailedCause !== ''"
            color="blue darken-1"
            flat
            @click="requestChanges"
          >
            Wyślij
          </v-btn>
          <v-btn color="blue" @click="correction.dialog = false">
            Anuluj
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="withdrawal.dialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">Anulowanie projektu</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            browser-autocomplete="off"
            data-vv-name="withdrawalCause"
            data-vv-as="Powód anulowania projektu"
            label="Powód anulowania projektu"
            :error-messages="vErrors.collect('withdrawalCause')"
            v-validate="'required'"
            @keydown="onKeyDownEvent"
            v-model="withdrawal.cause"
            aria-label="withdrawal cause"
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="withdrawal.cause !== ''"
            color="blue darken-1"
            flat
            @click="withdrawProject"
          >
            Zatwierdź
          </v-btn>
          <v-btn color="blue" @click="withdrawal.dialog = false">
            Zamknij
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Project } from "@/api/generated/Project";
import { Annex } from "@/api/generated/Annex";

export default {
  name: "ProjectPanelView",

  data() {
    return {
      project: {
        projectCode: "",
        title: "",
        bidderName: "",
        status: "",
        departmentId: null,
        agreementNumber: null,
        agreementSignDate: null,
        annexes: [],
        isHidden: false,
        isArchived: false,
        correspondenceRemarks: null,
        monitoringRemarks: null,
        volunteerRemarks: null,
      },
      correction: {
        dialog: false,
        cause: "",
        detailedCause: "",
      },
      withdrawal: {
        dialog: false,
        cause: "",
      },
    };
  },

  computed: {
    getExtraStatus() {
      let result = "";
      result += this.project.isHidden ? " (Projekt ukryty)" : "";
      result += this.project.isArchived ? " (Projekt archiwalny)" : "";
      return result;
    },

    getStatus() {
      if (this.project.status === "WITHDRAWN") return "anulowany";
      else if (this.project.status === "APPROVED")
        return "zatwierdzony do realizacji";
      else if (this.project.status === "REQUESTED_CHANGES")
        return "oddany do poprawki";
      else if (this.project.status === "POST_CORRECTION_MAIN")
        return "oczekuje na akceptację";
      else if (this.project.status === "AGREEMENT_SIGNED")
        return "umowa podpisana";
      else if (this.project.status === "NEW") return "nowy";
      else if (this.project.status === "CORRECTED") return "poprawiony";
      else if (this.project.status === "FINISHED") return "zakończony";
      else return null;
    },

    projectCanBeHidden() {
      return (
        this.project.isHidden === false &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    projectHidingCanBeUndone() {
      return (
        this.project.isHidden &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    projectCanBeArchived() {
      return (
        this.project.isArchived === false &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    projectArchivingCanBeUndone() {
      return (
        this.project.isArchived &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    projectCanBeFinished() {
      return (
        (this.project.status === "APPROVED" ||
          this.project.status === "AGREEMENT_SIGNED") &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    projectFinishingCanBeUndone() {
      return (
        this.project.status === "FINISHED" &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },
  },

  watch: {
    "correction.dialog": function(val) {
      if (!val) {
        this.correction.cause = "";
        this.correction.detailedCause = "";
      }
    },
  },

  methods: {
    archiveProject() {
      this.$confirm("Czy na pewno chcesz archiwizować projekt?", {
        icon: "warning",
        title: "Archiwizacja projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putArchive(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Projekt został pomyślnie archiwizowany",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się archiwizować projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    undoArchiveProject() {
      this.$confirm("Czy na pewno chcesz cofnąć archiwizację projektu?", {
        icon: "warning",
        title: "Cofnięcie archiwizacji projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putUndoArchive(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Archiwizacja projektu została pomyślnie cofnięta",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się cofnąć archiwizacji projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    hideProject() {
      this.$confirm("Czy na pewno chcesz ukryć projekt?", {
        icon: "warning",
        title: "Ukrycie projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putHide(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Projekt został pomyślnie ukryty",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się ukryć projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    undoHideProject() {
      this.$confirm("Czy na pewno chcesz cofnąć ukrycie projektu?", {
        icon: "warning",
        title: "Cofnięcie ukrycia projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putUndoHide(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Ukrycie projektu zostało pomyślnie cofnięte",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się cofnąć ukrycia projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    onKeyDownEvent(evt) {
      if (
        this.correction.cause.length >= 255 &&
        evt.keyCode >= 48 &&
        evt.keyCode <= 90
      )
        evt.preventDefault();
    },

    approveProject() {
      Project.putApprove(this, this.$route.params.projectId, () => {
        this.loadData();
      });
    },

    requestChanges() {
      Project.putRequestChanges(
        this,
        this.$route.params.projectId,
        this.prepareData(),
        () => {
          this.correction.dialog = false;
          this.loadData();
        }
      );
    },

    prepareWithdrawalData() {
      return {
        withdrawalCause: this.withdrawal.cause,
      };
    },

    withdrawProject() {
      Project.putWithdraw(
        this,
        this.$route.params.projectId,
        this.prepareWithdrawalData(),
        (successResponse) => {
          this.withdrawal.dialog = false;
          this.loadData();
          this.$messagesBus.$emit(
            "success",
            "Pomyślnie anulowano projekt",
            successResponse
          );
        },
        (errorResponse) => {
          this.$messagesBus.$emit(
            "error",
            "Nie udało się anulować projektu",
            errorResponse
          );
        }
      );
    },

    undoProjectWithdrawal() {
      this.$confirm("Czy na pewno chcesz cofnąć anulowanie projektu?", {
        icon: "warning",
        title: "Cofnięcie anulowania projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putUndoWithdrawal(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie cofnięto anulowano projektu",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się cofnąć anulowania projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    finishProject() {
      this.$confirm("Czy na pewno chcesz oznaczyć projekt jako zakończony?", {
        icon: "warning",
        title: "Zakończenie projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putFinish(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.project.status = "FINISHED";
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie zakończono projekt",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się zakończyć projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    undoFinishProject() {
      this.$confirm("Czy na pewno chcesz cofnąć zakończenie projektu?", {
        icon: "warning",
        title: "Cofnięcie zakończenia projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putUndoFinish(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.project.status = successResponse;
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie cofnięto zakończenie projektu",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się cofnąć zakończenia projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    prepareData() {
      return {
        correctionCause: this.correction.cause,
        detailedCorrectionCause: this.correction.detailedCause,
      };
    },

    projectCanBeWithdrawn() {
      return (this.project.status !== "WITHDRAWN" && this.project.status !=="FINISHED") && this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
    },

    projectWithdrawalCanBeUndone() {
      return (
        this.project.status === "WITHDRAWN" &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    projectCanBeApproved() {
      return (
        (this.project.status === "NEW" ||
          this.project.status === "CORRECTED") &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    projectCanHaveRequestChanges() {
      if (this.project.isHidden || this.project.isArchived) {
        return false;
      }
      return (
        this.project.status === "NEW" ||
        this.project.status === "CORRECTED" ||
        (this.project.isAwaitingAnnexSigning &&
          this.project.status !== "REQUESTED_CHANGES" &&
          this.project.status !== "POST_CORRECTION_MAIN" &&
          this.project.status !== "WITHDRAWN")
      );
    },

    possibleToUndoneApproval() {
      return (
        this.project.status === "APPROVED" &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    possibleToUndoneRequestChanges() {
      return (
        (this.project.status === "REQUESTED_CHANGES" ||
          this.project.status === "POST_CORRECTION_MAIN") &&
        (this.roles.isAdministrator() || this.roles.isLocalAdministrator())
      );
    },
    possibleToUndoAgreementSigned() {
      return (
        !this.project.annexes.length &&
        this.project.status === "AGREEMENT_SIGNED" &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },
    possibleToUndoAnnexApplication() {
      return (
        this.project.annexes.length &&
        this.project.isAwaitingAnnexSigning &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },
    possibleToUndoAddAnnex() {
      return (
        this.project.annexes.length &&
        !this.project.isAwaitingAnnexSigning &&
        this.$store.state.projectPanelPermissions
          .hasProjectPanelSupervisorModificationAccess
      );
    },

    undoApproval() {
      this.$confirm("Czy na pewno chcesz wycofać zatwierdzenie projektu?", {
        icon: "warning",
        title: "Wycofanie zatwierdzenia projektu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putUndoApproval(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie wycofano zatwierdzenie projektu",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się wycofać zatwierdzenia projektu",
                errorResponse
              );
            }
          );
        }
      });
    },

    undoRequestChanges() {
      this.$confirm("Czy na pewno chcesz wycofać projekt z poprawki?", {
        icon: "warning",
        title: "Wycofanie z poprawki",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Project.putUndoRequestChanges(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie wycofano projekt z poprawki",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się wycofać projektu z poprawki",
                errorResponse
              );
            }
          );
        }
      });
    },

    undoAgreementSigned() {
      this.$confirm(
        "Czy na pewno chcesz wycofać podpisanie umowy? Jeżeli podpisany plik sprawozdania końcowego został załączony do projektu, to zostanie on usunięty.",
        {
          icon: "warning",
          title: "Wycofanie podpisania umowy",
          color: "primary",
          width: 500,
        }
      ).then((response) => {
        if (response) {
          Project.putAgreement(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie wycofano podpisanie umowy",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się wycofać podpisania umowy",
                errorResponse
              );
            }
          );
        }
      });
    },

    undoAnnexApplication() {
      this.$confirm(
        "Czy na pewno chcesz wycofać przyjęcie wniosku o podpisanie aneksu?",
        {
          icon: "warning",
          title: "Wycofanie przyjęcia wniosku o podpisanie aneksu",
          color: "primary",
          width: 500,
        }
      ).then((response) => {
        if (response) {
          Annex.deleteApplication(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie wycofano przyjęcie wniosku o podpisanie aneksu",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się wycofać przyjęcia wniosku o podpisanie aneksu",
                errorResponse
              );
            }
          );
        }
      });
    },

    undoAddAnnex() {
      this.$confirm("Czy na pewno chcesz wycofać podpisanie aneksu?", {
        icon: "warning",
        title: "Wycofanie podpisania aneksu",
        color: "primary",
        width: 500,
      }).then((response) => {
        if (response) {
          Annex.delete(
            this,
            this.$route.params.projectId,
            (successResponse) => {
              this.loadData();
              this.$messagesBus.$emit(
                "success",
                "Pomyślnie wycofano podpisanie aneksu",
                successResponse
              );
            },
            (errorResponse) => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się wycofać podpisania aneksu",
                errorResponse
              );
            }
          );
        }
      });
    },

    loadData() {
      Project.getBasicData(this, this.$route.params.projectId, (success) => {
        this.project.status = success.projectStatus;
        this.project.projectCode = success.projectCode;
        this.project.title = success.title;
        this.project.bidderName = success.mainBidder.polishName;
        this.project.departmentId = success.departmentId;
        this.project.agreementNumber = success.agreementNumber;
        this.project.agreementSignDate = success.agreementSignDate;
        this.project.annexes = success.annexes;
        this.project.annexRemarks = success.annexRemarks;
        this.project.donationContractRemarks = success.donationContractRemarks;
        this.project.correspondenceRemarks = success.correspondenceRemarks;
        this.project.monitoringRemarks = success.monitoringRemarks;
        this.project.volunteerRemarks = success.volunteerRemarks;
        this.project.isHidden = success.isHidden;
        this.project.isArchived = success.isArchived;
        this.project.isAwaitingAnnexSigning = success.isAwaitingAnnexSigning;
      });
    },

    moveToHistory() {
      this.$router.push(
        "/app/project/" + this.$route.params.projectId + "/history"
      );
    },

    viewProject() {
      this.$router.openInNewTab(
        "/view/project/" + this.$route.params.projectId
      );
    },

    refresh() {
      this.loadData();
    },

    mailTo() {
      Project.getMainBidderEmail(
        this,
        this.$route.params.projectId,
        (success) => {
          window.location.href = "mailto:" + success.bidderEmail;
        }
      );
    },
  },

  created() {
    this.loadData();
    this.$store.commit("loadProjectPanelPermissions", {
      context: this,
      projectId: this.$route.params.projectId,
    });
  },
};
</script>

<style scoped>
a {
  color: #fff;
}
</style>
